import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../../context/AppContext';
import SafeIcon from '../../common/SafeIcon';

export default function FeaturedClubsBadges() {
  const location = useLocation();
  const { isAuthenticated } = useApp();
  const [isDismissed, setIsDismissed] = useState(false);

  // Do not show on Admin, Profile, Login, or Invitacion pages
  const hiddenPaths = ['/admin', '/perfil', '/login', '/recuperar-password', '/reset-password', '/invitacion', '/negocio'];
  const isHiddenPath = hiddenPaths.some(path => location.pathname.startsWith(path));

  // Hide on root Landing page if not authenticated
  const isLanding = !isAuthenticated && location.pathname === '/';

  // If path is forbidden, return early
  if (isHiddenPath || isLanding) return null;

  // Fixed Category Badges
  const badges = [
    { id: 'mate', nombre: 'Club del Mate', tipo: 'Mateada', emoji: '🧉' },
    { id: 'asado', nombre: 'Asado Comunitario', tipo: 'Asado', emoji: '🥩' }
  ];

  return (
    <div className="fixed bottom-24 md:bottom-28 right-4 md:right-8 z-40 flex flex-col gap-3 items-end pointer-events-none">
      <AnimatePresence>
        {!isDismissed && (
          <motion.button
            key="close-badges"
            initial={{ opacity: 0, x: 20, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 20, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
            onClick={() => setIsDismissed(true)}
            className="pointer-events-auto flex items-center justify-center w-6 h-6 bg-white/60 hover:bg-white backdrop-blur-md border border-stone-200 rounded-full text-stone-400 hover:text-stone-600 shadow-sm transition-colors mb-[-4px]"
            title="Ocultar accesos rápidos"
          >
            <SafeIcon name="X" className="w-3 h-3" />
          </motion.button>
        )}
        
        {!isDismissed && badges.map((badge, idx) => (
          <motion.div
            key={badge.id}
            initial={{ opacity: 0, x: 20, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 20, scale: 0.9 }}
            transition={{ delay: (idx + 1) * 0.1, type: "spring", stiffness: 200, damping: 20 }}
            className="pointer-events-auto"
          >
            <Link 
              to={`/clubs?tipo=${badge.tipo}`}
              className="bg-white/90 backdrop-blur-md border border-stone-200 hover:border-[#F6B40E] shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 rounded-full flex items-center gap-3 pr-5 pl-2 py-2 group"
            >
              <div className="w-8 h-8 rounded-full bg-[#F6B40E]/10 flex items-center justify-center group-hover:bg-[#F6B40E] transition-colors shadow-sm text-lg">
                {badge.emoji}
              </div>
              <span className="font-bold text-sm text-[#1B2A4E] group-hover:text-[#74ACDF] transition-colors whitespace-nowrap label-technical tracking-normal">
                {badge.nombre}
              </span>
            </Link>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}